import { useTheme } from '../contexts/ThemeContext';
import styles from './ThemeToggle.module.css';

/**
 * The Lightbox / Darkroom switch. A switch named "Darkroom": on is the dark
 * theme. "Lightbox" is shown beside it for sighted users but kept out of the
 * name, so a screen reader hears "Darkroom, switch, on/off".
 */
export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const dark = theme === 'dark';

  return (
    <button
      type="button"
      role="switch"
      aria-checked={dark}
      className={styles.toggle}
      onClick={() => setTheme(dark ? 'light' : 'dark')}
    >
      <span className={`${styles.label} ${styles.lightbox}`} aria-hidden="true">
        Lightbox
      </span>
      <span className={styles.track} aria-hidden="true">
        <span className={styles.thumb} />
      </span>
      <span className={`${styles.label} ${styles.darkroom}`}>Darkroom</span>
    </button>
  );
}
